import { render, staticRenderFns } from "./series.vue?vue&type=template&id=5936bbe0"
import script from "./series.vue?vue&type=script&lang=js"
export * from "./series.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports